import moment from "moment";
import React, { ButtonHTMLAttributes, FC, useEffect, useMemo, useRef, useState } from 'react';
import { GoogleReCaptcha, GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { Link, useHistory, useLocation, useParams } from 'react-router-dom';
import {
  addCartItem, countUp,
  getBookmarks,
  getCarts,
  getProductCustomList,
  getProductDetail,
  getRelatedProducts,
  postBookmark
} from '../apis/products';
import { BookmarkButton } from '../components/BookmarkButton';
import { Button } from '../components/Button';
import { sumTotalCountOfCarts } from '../components/CartCounterBadge';
import { CartPopUp } from '../components/CartPopUp';
import { H5 } from '../components/H5';
import { Icon } from '../components/Icon';
import { InfoGuidePopUp } from '../components/InfoGuidePopUp';
import { ProductCard } from '../components/ProductCard';
import { ProductTag } from '../components/ProductTag';
import { Section } from '../components/Section';
import { SizeGuidePopUp } from '../components/SizeGuidePopUp';
import { AIRBRIDGE_EVENT } from '../constants/airbridge';
import { BRAZE_EVENT } from "../constants/braze";
import { useUserDispatch, useUserState } from '../context/UserContext';
import { Bridge } from '../plugins/bridge';
import ReactPixel from "../plugins/facebookPixel";
import gtag from '../plugins/gtag';
import { nToast } from '../plugins/reactToast';
import { CartResponse, ProductDetail, ProductQuery, ProductSize,ScoreType ,TargetType } from '../types/types';
import { addProductHistory, getProductHistory } from '../utils/productHistory';
import { sortedSizeObjects } from '../utils/sortedSizes';
import injectSizesIntoProductList from '../utils/injectSizesIntoProductList';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion, { AccordionProps } from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import MuiAccordionSummary, { AccordionSummaryProps } from '@mui/material/AccordionSummary';
import { styled } from '@mui/material/styles';
import { ProductLDScript } from '../components/ProductLDScript';
import { Image } from '../components/Image';
import KakaoPixel from '../plugins/kakao';
//import Logger from '../plugins/logger';
import NaverPixel from '../plugins/naverPixel';
import { scoreUp } from '../../src/apis/score';

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
// Import Swiper styles
import 'swiper/components/navigation/navigation.min.css';
import 'swiper/components/pagination/pagination.min.css';
import 'swiper/swiper.min.css';
// import Swiper core and required modules
import qs from "qs";
import { isAndroid, isIOS, isMobile } from "react-device-detect";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import SwiperCore, { Keyboard, Navigation, Pagination } from 'swiper/core';
import { getContentDetail } from '../apis/contents';
import { postOrders } from "../apis/orders";
import { LoginPopUp } from "../components/LoginPopUp";
import { PopUp } from "../components/PopUp";
import {api} from "../plugins/axios";
import {VerificationPopup} from "../components/VerificationPopup";
// install Swiper modules
SwiperCore.use([Pagination, Navigation, Keyboard]);

const Accordion = styled((props: AccordionProps) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `none`,
  '&:not(:last-child)': {
    borderBottom: 0,
  },
  '&:before': {
    display: 'none',
  },
}));
const AccordionSummary = styled((props: AccordionSummaryProps) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
    {...props}
  />
))(({ theme }) => ({
  flexDirection: 'row-reverse',
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(-90deg)',
  },
  '& .MuiAccordionSummary-content': {
    marginLeft: theme.spacing(1),
  },
}));

const addCartItemValidator = (myCart: CartResponse, sizeTab: ProductSize, quantity: number): boolean => {
  // 해당 상품(sku)의 장바구니 항목
  const cart = myCart.carts.find(cart => cart.size.id === sizeTab.productSizeId);

  if (cart) { // 이미 장바구니에 담은 상품일 때
    const availableCount = sizeTab.currentStock;
    const targetCount = cart.count + quantity;

    if (availableCount < targetCount) {
      nToast('최대 수량을 초과했습니다.');
      return false;
    }
  }

  return true;
};



export const ProductPage = () => {
  const { location } = useHistory();
  const { id } = useParams<{ id: string; }>();
  const numId = parseInt(id);
  const [sizeTab, setSizeTab] = useState<ProductSize>();
  const [mobileSize, setMobileSize] = useState(false);
  const [desktopSize, setDesktopSize] = useState(true);
  const [sizePopup, setSizePopUp] = useState(false);
  const [infoPopup, setInfoPopUp] = useState(false);
  const [cartPopup, setCartPopUp] = useState(false);
  const [loginPopup, setLoginPopUp] = useState(false);
  const [isUrlPopup, setIsUrlPopup] = useState(false);
  const [loginVerified, setLoginVerified] = useState(false);
  const [isDownloadPopup, setIsDownloadPopup] = useState(false);
  const [buyCheckPopup, setBuyCheckPopup] = useState(false);
  const [checkMessage, setCheckMessage] = useState<string>('');
  const { push } = useHistory();
  const [product, setProduct] = useState<ProductDetail>();
  const [relatedProducts, setRelatedProducts] = useState<ProductQuery[]>([]);
  const [historyProducts, setHistoryProducts] = useState<ProductQuery[]>([]);
  const [isBookMarked, setIsBookMarked] = useState<boolean>(false);
  /*const [bigSliderOpen, setBigSliderOpen] = useState<boolean>(false);*/
  /*const [currentPage, setCurrentPage] = useState<number>(0);*/
  const { isLoggedIn, userInfo } = useUserState();
  const [myCart, setMyCart] = useState<CartResponse>({ carts: [], deliveryPrice: 0 });
  const { search } = useLocation();
  const userDispatch = useUserDispatch();
  const mounted = useRef(false);
  const [storeUrl, setStoreUrl] = useState<string>('');
  const [verifiedPopup, setVerifiedPopup] = useState(false);
  const query = qs.parse(location.search, { ignoreQueryPrefix: true });
  // 상품 실측 이미지
  const schemeImageUrl = product?.images.find(
    image => image.type === 'SCHEME',
  )?.originalUrl;

  const showSizeGuidePopupButton = useMemo(() => {
    return product?.productSizes.some(size => size.actualMeasures);
  }, [product?.productSizes]);

  const [mySwiper, setMySwiper] = useState<SwiperCore>();

  const setMetaTags = ({ title = "칼하트윕 코리아"
    , description = "매 시즌 아이코닉한 아이템으로 다양한 컬러웨이를 담아내는 스트릿 패션 브랜드 칼하트윕을 만나보세요."
    , imageUrl = "" }) => {
    //set title
    document.querySelector('meta[property="og:title"]')?.setAttribute("content", title);
    //set description
    document.querySelector('meta[property="og:description"]')?.setAttribute("content", description);
    //set images
    document.querySelector('meta[property="og:image"]')?.setAttribute("content", imageUrl ? imageUrl : "");
    //set url
    //document.querySelector('meta[property="og:url"]')?.setAttribute("content", location.pathname? "https://www.carhartt-wip.co.kr" + location.pathname : "https://www.carhartt-wip.co.kr");
  };

  const fetchCarts = () => getCarts().then(response => {
    setMyCart(response.data.payload);
    return response;
  }).catch(e => console.log(e));
  const [expanded, setExpanded] = useState<string[]>(['panel1', 'panel2', 'panel3', 'panel4']);
  const handleChange =
    (panel: string) => (event: React.ChangeEvent<{}>, isExpanded: boolean) => {
      setExpanded(isExpanded ? expanded?.filter((v) => v !== panel) : [...expanded, panel]);
    };

  useEffect(() => {
    if (!mounted.current) mounted.current = true;
    else {
      if (!!query.contentId) {
        const content_id = query.contentId as string;
        const onClickMainContentProduct = async (content_id: string) => {
          const content_name = (await getContentDetail(Number(content_id))).data.payload.title;

          Bridge.sendAmplitude('content_item_clicked', {
            content_id: content_id,
            content_name: String(content_name),
            item_id: [String(product?.productId)],
            item_name: [String(product?.productName)],
            item_category: [String(product?.categoryCode)],
            item_color: [String(product?.productInfo.color)],
            item_gender: [String(product?.genderCode)],
            item_price: [Number(product?.currentPrice)],
            item_discount_rate: [Number(product?.discountedRate)],
            item_discount_price: [Number(product?.initialPrice)]
          });

          Bridge.sendBraze(BRAZE_EVENT.CONTENT_ITEM_CLICKED, {
            content_id: content_id,
            content_name: String(content_name),
            item_id: String(product?.productId),
            item_name: String(product?.productName),
            item_category: String(product?.categoryCode),
            item_color: String(product?.productInfo.color),
            item_gender: String(product?.genderCode),
            item_price: String(product?.currentPrice),
            item_discount_rate: String(product?.discountedRate),
            item_discount_price: String(product?.initialPrice)
          });
        };

        onClickMainContentProduct(content_id);
      }
      else {
        Bridge.sendAmplitude('item_detail_page_viewed', {
          item_id: [String(product?.productId)],
          item_name: [String(product?.productName)],
          item_category: [String(product?.categoryCode)],
          item_color: [String(product?.productInfo.color)],
          item_gender: [String(product?.genderCode)],
          item_price: [Number(product?.initialPrice)],
          item_discount_rate: [Number(product?.discountedRate)],
          item_discount_price: [Number(product?.currentPrice)]
        });

        Bridge.sendBraze(BRAZE_EVENT.ITEM_DETAIL_PAGE_VIEWED, {
          item_id: String(product?.productId),
          item_name: String(product?.productName),
          item_category: String(product?.categoryCode),
          item_color: String(product?.productInfo.color),
          item_gender: String(product?.genderCode),
          item_price: Number(product?.initialPrice),
          item_discount_rate: Number(product?.discountedRate),
          item_discount_price: Number(product?.currentPrice)
        });

        Bridge.sendAirbridge(AIRBRIDGE_EVENT.productView, {
          action: String(product?.categoryCode),
          semanticAttributes: {
            products: [{
              productID: Number(product?.productId),
              name: String(product?.productName),
              price: Number(product?.currentPrice),
              currency: "KRW"
            }]
          }
        });
      }
    }
    (product?.productId && countUp(product.productId, 'PRODUCT'))
  }, [product]);

  useEffect(() => {
    fetchCarts();
  }, []);

  useEffect(() => {
    setHistoryProducts([]);
    setRelatedProducts([]);
    window.scrollTo(0, 0);
    getProductDetail(numId).then(r => {
      const data = r.data.payload;
      // 이미지 순서 변경
      data.images.forEach(
        it =>
          it.sort = (90 <= it.sort ? it.sort % 90 : it.sort + 20)
      );
      setProduct(data);

      setMetaTags({
        title: `${data.brandName}-${data.productName} ${data.currentPrice} | 칼하트`,
        description: `브랜드 : ${data.brandName} 제품번호 : ${data.productCode} 제품 : ${data.productName} 
          - ${data.currentPrice.toLocaleString()}`,
        imageUrl: `${data.images[0]?.thumbnailUrl}`
      }
      );

      //Logger.viewContent(data);
      KakaoPixel.ViewContent(numId);
      ReactPixel.viewContent(numId, data.productName, data.currentPrice);
    }).catch(e => console.log(e));
    getRelatedProducts(numId).then(r => {
      const data = r.data.payload.productFittingCuts;
      let list = [];
      for (let item of data) list.push(item.productId);
      list.length > 0 &&
        getProductCustomList(list)
            .then(r => injectSizesIntoProductList(r.data.payload))
            .then(setRelatedProducts);
    }).catch(e => console.log(e));
  }, [id]);

  const productScoreUp = async (productId: number) => {
    const scoreType = query.scoreType as ScoreType ?? ScoreType.VIEW
    await scoreUp(productId, TargetType.PRODUCT, scoreType)
  }

  useEffect(() => {
    if (product) {
      if (isLoggedIn) {
        getBookmarks()
          .then(r => {
            if (r && r.data) {
              const data = r.data.payload;
              const liked =
                data.findIndex(item => item.id === product.productId) !== -1;
              setIsBookMarked(liked);
            }
          })
          .catch(e => setIsBookMarked(false));
      }
      //productScoreUp(product.productId);
      addProductHistory(product?.productId!);

      const his = getProductHistory();
      his.length > 0 &&
        getProductCustomList(his)
          .then(r => {
            injectSizesIntoProductList(r.data.payload).then(data => setHistoryProducts(
                data?.filter(it => it.productId !== product.productId).sort(
                    (a, b) =>
                        his.indexOf(a.productId) -
                        his.indexOf(b.productId),
                )
            ))
          }).catch(e => console.log(e));
    }
  }, [product, isLoggedIn]);

  const addBookmarks = async (id: number) => {
    var itemEventProperties = await getProductDetail(id).then(item => {
      return {
        item_id: [String(item.data.payload.productId)],
        item_name: [String(item.data.payload.productName)],
        item_category: [String(item.data.payload.categoryCode)],
        item_color: [String(item.data.payload.productInfo.color)],
        item_gender: [String(item.data.payload.genderCode)],
        item_price: [Number(item.data.payload.initialPrice)],
        item_discount_price: [Number(item.data.payload.currentPrice)],
        item_discount_rate: [Number(item.data.payload.discountedRate)]
      };
    });

    postBookmark({ targetId: id, targetType: 'PRODUCT' }).then(async r => {
      setIsBookMarked(!isBookMarked);
      var wishlist_count = await getBookmarks().then(r => { if (r && r.data) { return r.data.payload.length; } });

      if (!isBookMarked) {
        Bridge.sendAmplitude('setUserProperties#total_wishlist_items_count', Number(wishlist_count));
        Bridge.sendAmplitude('item_added_to_wishlist', itemEventProperties);
        Bridge.sendBraze(BRAZE_EVENT.ITEM_WISHLIST_ADDED, itemEventProperties);
      }

      else {
        Bridge.sendAmplitude('setUserProperties#total_wishlist_items_count', Number(wishlist_count) - 1);
        Bridge.sendAmplitude('item_deleted_from_wishlist', itemEventProperties);
        Bridge.sendBraze(BRAZE_EVENT.DELETED_FROM_WISHLIST, itemEventProperties);
      }
      nToast(!isBookMarked ? '관심상품에 추가되었습니다.' : '관심상품에서 제외되었습니다.');
      if (!isBookMarked && product) {
        ReactPixel.addToWishlist(id, product.productName, product.currentPrice);
        KakaoPixel.AddToWishlist(id);
      }

      const likeProductIdsStr = localStorage.getItem('car_likeProductIds');

      if (!isBookMarked) {
        if (!likeProductIdsStr) {
          localStorage.setItem('car_likeProductIds', `["${id}"]`);
          return;
        }
        const likeProductIds: string[] = JSON.parse(
          likeProductIdsStr,
        );
        localStorage.setItem(
          'car_likeProductIds',
          JSON.stringify([
            String(id),
            ...likeProductIds
              .filter(productId => productId !== String(id))
              .slice(0, 15),
          ]),
        );
      } else {
        if (!likeProductIdsStr) {
          return;
        }
        const likeProductIds: string[] = JSON.parse(
          likeProductIdsStr,
        );
        localStorage.setItem(
          'car_likeProductIds',
          JSON.stringify([
            ...likeProductIds
              .filter(_productId => _productId !== String(id))
              .slice(0, 15),
          ]),
        );
      }
    }).catch(e => {
      if (e.response.status === 403) nToast('로그인 후 이용해주세요.');
    });
  };

  useEffect( ()=> {
    if(product){
      setCheckMessage(
        (product.isOnlyOne ? '✅ 해당 상품은 단독구매상품입니다.\n' : '')
        + (product.unavailableMileage ? '✅ 해당 상품은 적립금 사용/적립이 불가능 합니다.\n' : '')
        + (product.unavailableCoupon ? '✅ 해당 상품은 쿠폰 사용이 불가능 합니다.\n' : '')
      )
    }
  })

  const handleBuyNow = () => {
    if (product && (product.isOnlyOne || product.unavailableMileage || product.unavailableCoupon) && !buyCheckPopup) {
      setBuyCheckPopup(true);
      return;
    }
    handleAddToCart({ logging: false }).then(r => {
          getCarts().then(item => {
        const myCart = item.data.payload.carts;
        const cartIds = myCart.filter(cart => cart.product.id == numId && cart.size.id == sizeTab?.productSizeId).map(cart => cart.cartId);
        if (0 < cartIds.length) {
          postOrders(cartIds).then(r => push('/cart/payment')).catch(e => console.log('postOrders e: ', e));
        }
        if (product) {
          Bridge.sendAmplitude('purchase_button_clicked', {
            'non_member_order': !isLoggedIn,
            item_id: String(product.productId),
            item_name: product.productName,
            item_brand: product.brandName,
            item_category: product.categoryCode,
            item_color: myCart.map((value) => value.product.color).join(','),
            item_gender: product.genderCode,
            item_size: myCart.map((value) => value.size.name).join(','),
            item_price: Number(product.initialPrice),
            item_discount_rate: Number(product.discountedRate),
            item_discount_price: Number(product.currentPrice),
            order_item_quantity: myCart.map(value => value.count).join(","),
            total_order_items_quantity: myCart.map(value => value.count).reduce((a, b) => a + b, 0),
          });
          Bridge.sendBraze(BRAZE_EVENT.PURCHASE_BUTTON_CLICKED, {
            'non_member_order': !isLoggedIn,
            item_id: String(product.productId),
            item_name: product.productName,
            item_brand: product.brandName,
            item_category: product.categoryCode,
            item_color: myCart.map((value) => value.product.color).join(','),
            item_gender: product.genderCode,
            item_size: myCart.map((value) => value.size.name).join(','),
            item_price: Number(product.initialPrice),
            item_discount_rate: Number(product.discountedRate),
            item_discount_price: Number(product.currentPrice),
            order_item_quantity: myCart.map(value => value.count).join(","),
            total_order_items_quantity: myCart.map(value => value.count).reduce((a, b) => a + b, 0),
          });
        }
      });
    }
    );
  };

  const handleAddToCart = async ({ location, logging = true }: { location?: string, logging?: boolean; }) => {
    if (sizeTab) {
      if (!addCartItemValidator(myCart, sizeTab, 1)) return;

      await addCartItem(numId, { count: 1, sizeId: sizeTab.productSizeId }).then(
        r => {
          var total_value = 0;
          var total_cart = 0;

          myCart.carts.forEach(product => {
            total_value += product.product.currentPrice;
            total_cart++;
          });

          Bridge.sendAmplitude('setUserProperties#total_cart_items_count', total_cart);
          if (logging) {
            Bridge.sendAmplitude('item_added_to_cart', {
              item_id: [String(product?.productId)],
              item_name: [String(product?.productName)],
              item_category: [String(product?.categoryCode)],
              item_size: [sizeTab.sizeName],
              item_color: [String(product?.productInfo.color)],
              item_gender: [String(product?.genderCode)],
              item_price: [Number(product?.initialPrice)],
              item_discount_rate: [Number(product?.discountedRate)],
              item_discount_price: [Number(product?.currentPrice)],
              order_item_quantity: [1]
            });

            Bridge.sendBraze(BRAZE_EVENT.ADDED_TO_CART, {
              item_id: String(product?.productId),
              item_name: String(product?.productName),
              item_category: String(product?.categoryCode),
              item_size: sizeTab.sizeName,
              item_color: String(product?.productInfo.color),
              item_gender: String(product?.genderCode),
              item_price: Number(product?.initialPrice),
              item_discount_rate: Number(product?.discountedRate),
              item_discount_price: Number(product?.currentPrice)
            });

            Bridge.sendAirbridge(AIRBRIDGE_EVENT.addToCart, {
              action: String(product?.categoryCode),
              semanticAttributes: {
                totalValue: total_value + Number(product?.currentPrice),
                currency: "KRW",
                totalQuantity: total_cart + 1,
                products: [{
                  productID: String(product?.productId),
                  name: String(product?.productName),
                  price: Number(product?.initialPrice),
                  currency: "KRW",
                  quantity: 1
                }]
              }
            });
          }
          fetchCarts().then((res) => userDispatch({ type: 'SET_CART_COUNT', payload: sumTotalCountOfCarts(res?.data.payload.carts!) }));
          setCartPopUp(true);
          setMobileSize(false);
          setDesktopSize(true);
          setTimeout(() => {
            closeCartPopup();
          }, 5000);

          // 장바구니 버튼 클릭에 Automatically Detected 가
          // 설정된 듯 하다. 만약 보다 세부적인 데이터 구성이 필요해
          // 수동으로 실행하려면 아래 코드의 주석을 해제하고 쓰면 된다.
          NaverPixel.addToCart();
          //Logger.addToCart();

          if (product) {
            ReactPixel.addToCart(numId, product.productName, product.currentPrice);
            gtag.ads.conversionActions.addToCart(product.currentPrice);
            gtag.ads.conversionActions.addToCartPage(product.currentPrice);
            KakaoPixel.AddToCart(numId);
          }
          if (location == 'login') {
            push('/login?location=/cart');
          }
        },
      ).catch(e => {
        console.log(e);
        if (e?.response?.data?.code == 'PRODUCT_ONLY_APP') {
          setIsDownloadPopup(true);
        }
        if (e?.response?.data?.code == 'PRODUCT_ONLY_USER' && location == 'login') {
          push('/login?location=/product/' + product?.productId);
        }
      });
    } else {
      setMobileSize(true);
      setDesktopSize(true);
    }
  };

  const closeCartPopup = () => {
    setCartPopUp(false);
    setSizeTab(undefined);
  };

  const changeProduct = (productId: number) => {
    push(`/product/${productId}`);
    window.location.reload();
  };

  const shareProduct = () => {
    if (navigator.share && product) {
      navigator.share({
        title: 'CARHARTT WIP',
        text: `[CARHARTT WIP]${product.brandName} ${product.productName} ${product.productInfo.color}`,
        url: document.location.href,
      });
    } else {
      setIsUrlPopup(true);
    }
  };

  const urlCopy = () => {
    const url = document.location.href;
    if (navigator.clipboard) {
      navigator.clipboard.writeText(url).then(r => {
        nToast('URL 복사 완료');
      });
    } else {
      fallbackCopyTextToClipboard(url);
    }
  };

  useEffect(() => {
    if (isAndroid) setStoreUrl('market://details?id=com.carharttmobile');
    else if (isIOS) setStoreUrl('https://tosto.re/carharttwipapp1');
  }, []);

  const fallbackCopyTextToClipboard = (url: string) => {
    const textArea = document.createElement("textarea");
    textArea.value = url;

    // Avoid scrolling to bottom
    textArea.style.top = "0";
    textArea.style.left = "0";
    textArea.style.position = "fixed";

    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      const successful = document.execCommand('copy');
      const msg = successful ? 'URL 복사 완료' : 'URL 복사 실패';
      nToast(msg);
    } catch (err) {
      nToast('브라우저 지원 불가');
      console.error('Fallback: Oops, unable to copy', err);
    }
    document.body.removeChild(textArea);
  };

  const isAvailable = !product?.availableFrom ? true : moment(product?.availableFrom) < moment();

  const clickSlideImage = (e: any) => {
    if(!isMobile) return;
    const currentMiddlePosition = e.target.offsetWidth / 2
    const clickPosition = e.clientX
    clickPosition > currentMiddlePosition ? mySwiper?.slideNext() : mySwiper?.slidePrev();
  }

  if (!product) return null;

  return (
    <>
        <HelmetProvider>
          <Helmet>
            <meta property="og:title" content={`${product.brandName}-${product.productName} ${product.currentPrice} | 칼하트`} />
            {/*<meta property="og:site_name" content={props.title} />*/}
            <meta property="og:description" content={`브랜드 : ${product.brandName} 제품번호 : ${product.productCode} 제품 : ${product.productName}`} />
            <meta property="og:image" content={`${product.images[0]?.thumbnailUrl}`} />
            {/*<meta property="og:url" content={props.url} />*/}
          </Helmet>
        </HelmetProvider>
        <style>
          {`.swiper-pagination-bullet-active {
            background-color: #ffffff !important;
            }
            .swiper-button-next {
                width: 20% !important;
                height: 100% !important;
                top: 0 !important;
                opacity: 0;
            }
            .swiper-button-prev {
                width: 20% !important;
                height: 100% !important;
                top: 0 !important;
                opacity: 0;
            }
            `
          }
        </style>
        <ProductLDScript productDetail={product} />
        <CartPopUp
          open={cartPopup}
          goCart={() => push('/cart')}
          product={product}
          size={sizeTab!}
          onClose={() => closeCartPopup()}
        />
      <VerificationPopup
          title="휴대폰 본인인증 진행"
          description="휴대폰 본인인증 후에 웍스아웃의 더 많은 혜택을 누려보세요."
          description2={`
              <div style="font-weight: 600">
                  - 한정판 상품 응모 가능<br/>
                  - 한정판 상품 선착 발매 시 구매 가능<br/>
                  - 회원 전용 상품 발매 시 구매 가능
                </div>
              `}
          buttonText="휴대폰 본인인증"
          open={verifiedPopup}
          onClose={() => setVerifiedPopup(false)}
      />
        <LoginPopUp
          open={loginPopup}
          nonMemberOrder={() => handleBuyNow()}
          memberLogin={() => { handleAddToCart({ location: 'login' }); }}
          onClose={() => setLoginPopUp(false)}
        />
        <PopUp
          title='공유서비스가 지원되지 않는 환경입니다.'
          description="현재 URL을 복사 하시겠습니까?"
          buttonText="URL 복사"
          onClick={() => urlCopy()}
          open={isUrlPopup}
          onClose={() => setIsUrlPopup(false)}
        />
      <PopUp
          title={`${product?.isOnlyForUser ? '회원 전용 상품입니다.' : '구매 수량 제한 상품입니다.'}`}
          description="로그인 하시겠습니까?"
          buttonText="로그인 하기"
          onClick={() => push('/login')}
          open={loginVerified}
          onClose={() => setLoginVerified(false)}
      />
        <PopUp
          title='앱전용 상품입니다.'
          description="앱을 다운받으시겠습니까?"
          buttonText="앱 다운로드"
          onClickMobile={() => {
            window.open(
              storeUrl,
              '_blank',
            );
            setIsDownloadPopup(false);
          }}
          open={isDownloadPopup}
          onClose={() => setIsDownloadPopup(false)}
        />
        <SizeGuidePopUp
          open={sizePopup}
          onClose={() => setSizePopUp(false)}
          productSizes={product.productSizes}
          schemeImageUrl={schemeImageUrl}
        />

        <InfoGuidePopUp
          open={infoPopup}
          onClose={() => setInfoPopUp(false)}
          productInfo={product.productInfo}
        />

        <PopUp
            title="아래 내용을 확인해주세요."
            description={checkMessage}
            buttonText="동의하고 구매하기"
            open={buyCheckPopup}
            onClose={() => setBuyCheckPopup(false)}
            onClick={() => handleBuyNow()}
            onClickMobile={() => handleBuyNow()}
        />

        {/*<BigSlider
        open={bigSliderOpen}
        images={product.images}
        onClose={() => setBigSliderOpen(false)}
        page={currentPage}
      />*/}

        <div className=" max-w-screen-xl md:mx-auto flex md:flex-row flex-col md:space-x-8 md:pt-14 -mx-4 pt-5">
          {/* Image Slider Section */}
          <Swiper className="mySwiper md:w-1/2 w-full z-10 -mt-6 -mb-2 md:-mt-0 h-full"
            onInit={(slide)=>{setMySwiper(slide)}}
            loop={true}
            keyboard={{
              enabled: true
            }}
            navigation={!isMobile}
            pagination
            speed={500}
          >
            {/*className="md:w-1/2 w-full z-10 -mt-6 -mb-2 md:-mt-0 ">*/}
            {product.images
              .filter(item => item.type === 'DETAIL' || item.type === 'THUMBNAIL' || item.type === 'FITTING')
              .sort((a, b) => a.sort - b.sort)
              .map((item, index) => {
                return (
                  <SwiperSlide key={`${item.thumbnailUrl}-${index}`}>
                    <div
                      className="m-auto aspect-w-2 aspect-h-3"
                      key={index}
                    /*onClick={() => setBigSliderOpen(true)}*/
                    >
                      <Image
                          imgUrl={item.originalUrl || ''}
                          className="w-full h-full object-cover"
                          clickSlideImage={(e)=> clickSlideImage(e)}
                      />
                    </div>
                  </SwiperSlide>
                );
              })}
          </Swiper>

          {/* Product Info Section */}
          <Section className="md:w-2/5 space-y-3 p-4 md:p-0">
            <div className="hidden md:flex space-x-2">
              {product.isMidsale && <ProductTag name={'시즌 오프'} />}
              {product.isNewArrival && <ProductTag name={'신상품'} />}
              {product.isOnlyForUser && <ProductTag name={'회원전용'} />}
            </div>

            <div className="hidden md:block">
              <H5 className="font-semibold text-brand-3">
                <span className="text-brand-1">{product.productName}</span>
                <br />
                {product.productInfo.color}
                <br />
                {product.productKoreanName} {product.productInfo.colorKoreanName}{' '}
                <br />
                {product.productCode} <br />
                {product.discountedRate > 0 && (
                  <>
                    <span className="text-gray-400 text-15 line-through">₩ {product.initialPrice.toLocaleString()}</span>
                    &nbsp;&nbsp;
                    <span className="text-red-500 text-15">{product.discountedRate}% 할인</span>
                    <br />
                  </>
                )}
                <span className="text-brand-1">
                  ₩ {product.currentPrice.toLocaleString()} <br />
                </span>
              </H5>
            </div>

            <div className="text-13 text-gray-600 leading-relaxed relative">
              {product.fittingSize && (
                <>
                  <p className="">
                    {product.fittingWeight != 0 ?
                      `키/몸무게: ${product.fittingHeight}cm / ${product.fittingWeight}kg`
                      :
                      `키: ${product.fittingHeight}cm`
                    }
                  </p>
                  <p className="">착용 사이즈 : {product.fittingSize}</p>
                </>
              )}
              {showSizeGuidePopupButton && (
                <button onClick={() => setSizePopUp(true)} className="underline">
                  사이즈 가이드
                </button>
              )}
              {/*<button className="absolute right-0 top-2 md:hidden block" onClick={()=>shareProduct()}><Icon.Upload className="wh-6" /></button>*/}
            </div>

            <button
              onClick={() => setInfoPopUp(true)}
              className="text-13 text-gray-600 underline pt-5">
              상품 정보 고시
            </button>

            {!product.onlyOffline && (
              <div className="hidden md:block space-y-1">
                <div className="grid grid-cols-6">
                  {sortedSizeObjects(product.productSizes, 'sizeName')
                    .map((size, index) => (
                      <SizeTab
                        key={index}
                        item={size}
                        selected={size.productSizeId === sizeTab?.productSizeId}
                        onClick={() => setSizeTab(size)}
                      />
                    ))}
                </div>
                {product.productSizes.find(
                  s => s.productSizeId === sizeTab?.productSizeId,
                )?.currentStock === 1 && (
                    <p className="text-red-600 text-13 ">마지막 재고입니다.</p>
                  )}
              </div>
            )}

            <div className="flex md:pt-2 items-center md:flex hidden">
              <Button
                // onTouchStart={()=>(`eval('try{ _trk_clickTrace( \'SCI\', ${product.productId || ""} ); }catch(_e){}');`)}
                onClick={() => isLoggedIn ?
                    (product.isOnlyForUser || product.availableStockUser > 0
                        ? (userInfo && userInfo.isVerified
                            ? handleBuyNow()
                            : setVerifiedPopup(true))
                        : handleBuyNow())
                    : (product.isOnlyForUser || product.availableStockUser > 0
                        ? setLoginVerified(true)
                        : setLoginPopUp(true))
                }
                text={`${!isAvailable ? `${moment(product.availableFrom).format('YYYY.MM.DD HH:mm')} 부터 구매 가능` :
                  product.onlyOffline ? '오프라인 전용 상품' :
                    desktopSize && sizeTab
                      ? '구매하기'
                      : desktopSize && !sizeTab
                        ? (product.productSizes.findIndex(item => item.currentStock > 0) > -1 ? "사이즈 선택해주세요" : "품절")
                        : ''
                  } `}
                className={`${!isAvailable ? `filled-brand-2 text-gray-300 my-2 mr-1 w-full cursor-default` :
                  product.onlyOffline ? 'filled-brand-2 text-gray-300 my-2 mr-1 w-full cursor-default' :
                    desktopSize && sizeTab
                      ? 'buy_ani filled-brand-1 my-2 mr-1 w-full hover:opacity-70 duration-300'
                      : desktopSize && !sizeTab
                        ? (product.productSizes.findIndex(item => item.currentStock > 0) > -1 ? "bg-gray-800 text-white my-2 mr-1 w-full cursor-default" : "filled-brand-2 text-gray-300 my-2 mr-1 w-full cursor-default")
                        : ''
                  } `}
              />
              <Button
                // onTouchStart={()=>(`eval('try{ _trk_clickTrace( \'SCI\', ${product.productId || ""} ); }catch(_e){}');`)}
                onClick={() => isLoggedIn ?
                    (product.isOnlyForUser || product.availableStockUser > 0
                        ? (userInfo && userInfo.isVerified
                            ? handleAddToCart({})
                            : setVerifiedPopup(true))
                        : handleAddToCart({}))
                    :
                    (product.isOnlyForUser || product.availableStockUser > 0
                        ? setLoginVerified(true)
                        : handleAddToCart({}))}
                text={`${!isAvailable ? `` :
                  product.onlyOffline ? '' :
                    desktopSize && sizeTab
                      ? '장바구니 담기'
                      : ''
                  } `}
                className={`${!isAvailable ? `hidden` :
                  product.onlyOffline ? 'hidden' :
                    desktopSize && sizeTab
                      ? 'buy_ani border my-2 w-full'
                      : 'hidden'
                  } `}
              />
              <div
                className="flex items-center border ml-1 h-12 justify-center rounded-md relative cursor-pointer"
                onClick={() => addBookmarks(product.productId)}>
                <span className="absolute left-3.5">
                  <BookmarkButton preSelected={isBookMarked} />
                </span>
                <p className="w-11"></p>
              </div>
            </div>
            <Section className="space-y-6">
              {/*{isMobile && (*/}
              {/*    <button className={`relative w-full md:hidden block`}*/}
              {/*            onClick={() => {*/}
              {/*              const journal_id = 767;*/}
              {/*              const journal_name = ('KAKAO COUPON');*/}
              {/*              const content = {*/}
              {/*                content_tab: "WELCOME COUPON",*/}
              {/*                content_id: String(journal_id),*/}
              {/*                content_name: journal_name*/}
              {/*              }*/}
              {/*              Bridge.sendAmplitude('main_content_clicked', content);*/}
              {/*              push(`/journal/${journal_id}`);*/}
              {/*            }}>*/}
              {/*      <img src={`https://s3.ap-northeast-2.amazonaws.com/carhartt-wip.co.kr/static/media/CarharttKakaoBanner-dedail.jpeg`} alt=""/>*/}
              {/*      <div className={`absolute z-10 top-0 text-white w-full h-full flex flex-col items-center justify-center gap-y-1`}>*/}
              {/*        <p className={`text-md font-medium`}>카카오페이 결제 시 <span className={`text-kakao`}>5%(최대 2만원) 즉시할인</span></p>*/}
              {/*        <p className={`text-12`}>2023.06.01 - 06.30</p>*/}
              {/*      </div>*/}
              {/*    </button>*/}
              {/*)}*/}
              <div
                className={`pd_page ${expanded ? '' : ''
                  }`}
              >
                <Accordion
                  expanded={!expanded.includes('opend')}
                  onChange={handleChange('opend')}
                  className="text-12"
                >
                  <AccordionSummary
                    expandIcon={
                      <Icon.ChevronDown
                      />
                    }
                    style={{ padding: 0 }}
                  >
                    <div className="summary_t relative text-gray-800">
                      상세정보
                      <span className="summary"></span>
                    </div>
                  </AccordionSummary>
                  <AccordionDetails
                    className={`flex flex-col ml-2 gap-y-1 leading-5 whitespace-pre-wrap ${expanded ? '' : ''}`}
                  >
                    {product.info}
                  </AccordionDetails>
                </Accordion>
                <Accordion
                  expanded={!expanded.includes('panel1')}
                  onChange={handleChange('panel1')}
                  className="text-12"
                >
                  <AccordionSummary
                    expandIcon={
                      <Icon.ChevronDown
                      />
                    }
                    style={{ padding: 0 }}
                  >
                    <div className="summary_t relative text-gray-800">
                      배송 안내
                      <span className="summary"></span>
                    </div>
                  </AccordionSummary>
                  <AccordionDetails
                    className={`flex flex-col ml-2 gap-y-1 leading-5 whitespace-pre-wrap ${expanded ? '' : ''}`}
                  >
                    CJ대한통운 (1588-1255)<br />배송 지역 : 전국 (일부 지역 제외)<br />배송비 : 10만원 이상 구매 시 무료 배송<br />배송 기간 : 평일 오후 2시 이전 결제 완료 된<br />주문건은 당일 출고되며 배송은 1~3일 정도 소요됩니다.<br />
                    <Link to="/cc/custom/3" className=""><span className="border-b border-transparent hover:border-gray-500 text-gray-500">(자세히 보기)</span></Link>
                  </AccordionDetails>
                </Accordion>
                <Accordion
                  expanded={!expanded.includes('panel2')}
                  onChange={handleChange('panel2')}
                  className="text-12"
                >
                  <AccordionSummary
                    expandIcon={
                      <Icon.ChevronDown
                      />
                    }
                    style={{ padding: 0 }}
                  >
                    <div className="summary_t relative text-gray-800">
                      반품 안내
                      <span className="summary"></span>
                    </div>
                  </AccordionSummary>
                  <AccordionDetails
                    className={`flex flex-col ml-2 gap-y-1 leading-5 whitespace-pre-wrap ${expanded ? '' : ''}`}
                  >
                    <div>
                      교환/환불의 경우 모든 상품은 상품을 공급받으신 날로부터<br />
                      7일 이내 신청하시면 기사님께서 빠른 시일 내에 수거하실 예정입니다.<br />
                      고객님의 단순 변심으로 인한 상품의 교환/반품을 요청하시는 경우,<br />
                      택배비용은 고객님 부담이오니 이점 양해 바랍니다.<br />
                      칼하트 (마이페이지 &gt; 주문 내역 &gt; 주문서 상세 페이지 조회 &gt; 교환/환불 신청)<br />
                      <Link to="/cc/custom/4" className=""><span className="border-b border-transparent hover:border-gray-500 text-gray-500">(자세히 보기)</span></Link>
                    </div>
                  </AccordionDetails>
                </Accordion>
                <Accordion
                  expanded={!expanded.includes('panel3')}
                  onChange={handleChange('panel3')}
                  className="text-12"
                >
                  <AccordionSummary
                    expandIcon={
                      <Icon.ChevronDown
                      />
                    }
                    style={{ padding: 0 }}
                  >
                    <div className="summary_t relative text-gray-800">
                      A/S 안내
                      <span className="summary"></span>
                    </div>
                  </AccordionSummary>
                  <AccordionDetails
                    className={`flex flex-col ml-2 gap-y-1 leading-5 whitespace-pre-wrap ${expanded ? '' : ''}`}
                  >
                    <div>
                      칼하트윕 한국 공식 판매처를 통하여 구입한 모든 제품은<br/>A/S를 받으 실 수 있습니다.
                      <Link to="/cc/custom/1" className=""><span className="border-b border-transparent hover:border-gray-500 text-gray-500">(자세히 보기)</span></Link>
                    </div>
                  </AccordionDetails>
                </Accordion>
                <Accordion
                  expanded={!expanded.includes('panel4')}
                  onChange={handleChange('panel4')}
                  className="text-12"
                >
                  <AccordionSummary
                    expandIcon={
                      <Icon.ChevronDown
                      />
                    }
                    style={{ padding: 0 }}
                  >
                    <div className="summary_t relative text-gray-800">
                      세탁 및 취급 시 주의사항
                      <span className="summary"></span>
                    </div>
                  </AccordionSummary>
                  <AccordionDetails
                    className={`flex flex-col ml-2 gap-y-1 leading-5 whitespace-pre-wrap ${expanded ? '' : ''}`}
                  >
                    <div>
                      제품 혼용율에 따라 세탁 및 취급 유의 사항이 변경될 수 있습니다.<br />
                      반드시 부착되어 있는 케어라벨 내용을 확인하신 후 세탁하시기 바랍니다.<br />
                      따라서 세탁시에는 반드시 세탁 및 최급 시 주의사항 페이지를 참고 부탁 드립니다.<br />
                      <Link to="/cc/cautions-for-washing-and-handling" className=""><span className="border-b border-transparent hover:border-gray-500 text-gray-500">(자세히 보기)</span></Link>
                    </div>
                  </AccordionDetails>
                </Accordion>
              </div>
            </Section>
            {/*{!isMobile &&(*/}
            {/*    <button className={`relative w-full md:block hidden`}*/}
            {/*            onClick={() => {*/}
            {/*              const journal_id = 767;*/}
            {/*              const journal_name = ('KAKAO COUPON');*/}
            {/*              const content = {*/}
            {/*                content_tab: "WELCOME COUPON",*/}
            {/*                content_id: String(journal_id),*/}
            {/*                content_name: journal_name*/}
            {/*              }*/}
            {/*              Bridge.sendAmplitude('main_content_clicked', content);*/}
            {/*              push(`/journal/${journal_id}`);*/}
            {/*            }}>*/}
            {/*      <img src={`https://s3.ap-northeast-2.amazonaws.com/carhartt-wip.co.kr/static/media/CarharttKakaoBanner-dedail.jpeg`} alt=""/>*/}
            {/*      <div className={`absolute z-10 top-0 text-white w-full h-full flex flex-col items-center justify-center gap-y-1`}>*/}
            {/*        <p className={`text-xl font-medium`}>카카오페이 결제 시 <span className={`text-kakao`}>5%(최대 2만원) 즉시할인</span></p>*/}
            {/*        <p className={`text-12`}>2023.06.01 - 06.30</p>*/}
            {/*      </div>*/}
            {/*    </button>*/}
            {/*)}*/}
          </Section>
        </div>

        <div className="space-y-10 md:space-y-14">
          {/* 함께 착용한 상품 Section */}
          {relatedProducts.filter(item => item.brandName === 'CARHARTT WIP').length > 0 && (
            <Section className="space-y-3 max-w-screen-2xl mx-auto md:pt-44 pt-16">
              <H5 className="font-medium">함께 착용한 상품</H5>
              <Swiper
                slidesPerView={isMobile ? 2 : 4}
                spaceBetween={isMobile ? 10 : 24}
                className="mySwiper"
              >
                {relatedProducts
                  .filter(item => item.brandName === 'CARHARTT WIP')
                  .slice(0, 10)
                  .map((product, index) => (
                    <SwiperSlide key={`related-${product.productId}-${index}`}>
                      <ProductCard
                        key={index}
                        product={product}
                        //onClick={() => push(`/product/${product.productId}`)}
                        onClick={() => changeProduct(product.productId)}
                      />
                    </SwiperSlide>
                  ))}
              </Swiper>
            </Section>
          )}

          {/* 최근 본 상품 Section */}
          {historyProducts.filter(item => item.brandName === 'CARHARTT WIP').length > 0 && (
            <Section className="space-y-3 max-w-screen-2xl mx-auto md:px-0 mt-8 ">
              <H5 className="font-medium">최근 본 상품</H5>
              <Swiper
                slidesPerView={isMobile ? 2 : 4}
                spaceBetween={isMobile ? 10 : 24}
                className="mySwiper"
              >
                {historyProducts
                  .map((product, index) => (
                    <SwiperSlide key={`${product.productId}-${index}`}>
                      <ProductCard
                        key={index}
                        product={product}
                        //onClick={() => push(`/product/${product.productId}`)}
                        onClick={() => changeProduct(product.productId)}
                      />
                    </SwiperSlide>
                  ))}
              </Swiper>
            </Section>
          )}
        </div>

        {/* Mobile Button */}
        <div className="md:hidden fixed w-full bottom-0 shadow-top -mx-4 text-14 bg-white px-4 pt-2 font-bold" style={{zIndex: 99999999}}>
          <div className="flex justify-between leading-tight">
            <p className="">{product.productName}</p>
            <p className="">₩{product.currentPrice.toLocaleString()}</p>
          </div>
          <div className="flex justify-between ">
            <p className="text-brand-3">{product.productInfo.color}</p>
            {product.discountedRate > 0 && (
              <p className='text-right whitespace-nowrap'>
                <span className="text-gray-400 text-12 line-through">₩ {product.initialPrice.toLocaleString()}</span>
                &nbsp;&nbsp;
                <span className="text-red-500 text-12">{product.discountedRate}% 할인</span>
                <br />
              </p>
            )}
          </div>
          <p className="text-brand-3">{product.productKoreanName} {product.productInfo.colorKoreanName}</p>

          <div className="flex flex-col max-h-60 overflow-y-scroll overflow-x-hidden">
            {mobileSize && (
              <>
                <div className="buy_ani grid grid-cols-5 pt-1 space-4">
                  {product.productSizes.map((size, index) => (
                    <SizeTab
                      label="test"
                      key={index}
                      item={size}
                      selected={size.productSizeId === sizeTab?.productSizeId}
                      onClick={() => setSizeTab(size)}
                    />
                  ))}
                </div>
                {mobileSize &&
                  product.productSizes.find(
                    s => s.productSizeId === sizeTab?.productSizeId,
                  )?.currentStock === 1 && (
                    <p className="text-red-600 text-13 text-center pt-4 underline">
                      마지막 재고입니다.
                    </p>
                  )}
              </>
            )}
          </div>

          <div className="flex md:pt-4 items-center">
            <Button
              // onTouchStart={()=>(`eval('try{ _trk_clickTrace( \'SCI\', ${product.productId || ""} ); }catch(_e){}');`)}
              disabled={!isAvailable || product.onlyOffline || product.productSizes.findIndex(item => item.currentStock > 0) === -1 || (mobileSize && !sizeTab)}
              // onClick={() => mobileSize && sizeTab ? (isLoggedIn ? handleBuyNow() : setLoginPopUp(true)) : setMobileSize(true)}
              onClick={() => mobileSize && sizeTab ?
                  (isLoggedIn ?
                      (product.isOnlyForUser || product.availableStockUser > 0
                          ? (userInfo && userInfo.isVerified
                              ? handleBuyNow()
                              : setVerifiedPopup(true))
                          : handleBuyNow())
                      : setLoginPopUp(true))
                  :
                  setMobileSize(true)}
              text={`${!isAvailable ? `${moment(product.availableFrom).format('YYYY.MM.DD HH:mm')} 부터 구매 가능` :
                product.onlyOffline ? '오프라인 전용 상품' :
                  mobileSize && sizeTab
                    ? '구매하기'
                    : mobileSize && !sizeTab
                      ? '사이즈 선택'
                      : (product.productSizes.findIndex(item => item.currentStock > 0) > -1 ? "사이즈 선택" : "품절")
                } `}
              className={`${!isAvailable ? `filled-brand-1 my-2 mr-1 w-full` :
                product.onlyOffline ? 'filled-brand-1 my-2 mr-1 w-full' :
                  mobileSize && sizeTab
                    ? 'filled-brand-1 my-2 mr-1 w-full buy_ani'
                    : mobileSize && !sizeTab
                      ? 'filled-brand-1 my-2 mr-1 w-full'
                      : (product.productSizes.findIndex(item => item.currentStock > 0) > -1 ? "filled-brand-1 my-2 mr-1 w-full" : "filled-brand-1 my-2 mr-1 w-full")
                } `}
            />
            <Button
              // onTouchStart={()=>(`eval('try{ _trk_clickTrace( \'SCI\', ${product.productId || ""} ); }catch(_e){}');`)}
              disabled={!isAvailable || product.onlyOffline || product.productSizes.findIndex(item => item.currentStock > 0) === -1 || (mobileSize && !sizeTab)}
              onClick={() => isLoggedIn ?
                  (product.isOnlyForUser || product.availableStockUser > 0
                      ? (userInfo && userInfo.isVerified
                          ? handleAddToCart({})
                          : setVerifiedPopup(true))
                      : handleAddToCart({}))
                  :
                  (product.isOnlyForUser || product.availableStockUser > 0
                      ? setLoginVerified(true)
                      : handleAddToCart({}))}
              text={`${!isAvailable ? `${moment(product.availableFrom).format('YYYY.MM.DD HH:mm')} 부터 구매 가능` :
                product.onlyOffline ? '오프라인 전용 상품' :
                  mobileSize && sizeTab
                    ? '장바구니 담기'
                    : ''
                } `}
              className={`${!isAvailable ? `hidden` :
                product.onlyOffline ? 'hidden' :
                  mobileSize && sizeTab
                    ? 'border my-2 w-full buy_ani'
                    : 'hidden'
                } `}
            />
            <div
              className="flex items-center border ml-1 h-12 justify-center rounded-md relative cursor-pointer"
              onClick={() => addBookmarks(product.productId)}>
              <span className="absolute left-3.5">
                <BookmarkButton preSelected={isBookMarked} />
              </span>
              <p className="w-11"></p>
            </div>
          </div>
        </div>
    </>
  );
};

interface SizeTabProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  item: ProductSize;
  selected?: boolean;
  label?: string;
}

export const SizeTab: FC<SizeTabProps> = ({ item, selected, ...props }) => {
  return (
    <div className={'p-1'}>
      <button
        style={{ minHeight: 60 }}
        className={`text-14 w-full py-3 rounded-lg ${item.currentStock <= 0
          ? 'disabled text-gray-300 bg-brand-2'
          : selected
            ? 'bg-brand-1 text-white'
            : 'bg-brand-2 text-gray-900'
          }`}
        disabled={item.currentStock <= 0}
        {...props}>
        <p className={``}>{item.sizeName}</p>
      </button>
    </div>
  );
};
